import { render, staticRenderFns } from "./ResultNav.vue?vue&type=template&id=56ab06f7&"
import script from "./ResultNav.vue?vue&type=script&lang=js&"
export * from "./ResultNav.vue?vue&type=script&lang=js&"
import style0 from "./ResultNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports